<template>
  <li v-if="isVisible">
    <FileCheckbox
      v-if="label !== ''"
      v-model="isSelected"
      :label="label"
      :fullPath="fullPath"
      v-on:selectionValEv="thisUpdated"
    />

    <ul style="list-style-type:none;">
      <fileSelector
        v-for="(folder, index) in folders"
        :key="index"
        v-model="folder.isSelected"
        :label="folder.name"
        :fullPath="folder.fullPath"
        :folders="folder.folders"
        :files="folder.files"
        :isVisible="folder.isVisible"
        v-on:selectionValEv="childrenUpdated"
        v-on:fileSelectionChanged="emitFileSelChanged"
      />
      <li v-for="(file, index) in files" :key="index + 100">
        <FileCheckbox
          v-if="file.isVisible"
          v-model="file.isSelected"
          :label="file.name"
          :fullPath="fullPath + '/' + file.name"
          v-on:selectionValEv="fileUpdated"
        />
      </li>
    </ul>
  </li>
</template>

<script>
import FileCheckbox from './FileCheckbox.vue';

export default {
  name: 'fileSelector',
  components: {
    FileCheckbox,
  },
  model: {
    prop: 'selectionVal',
    event: 'selectionValEv',
  },
  props: {
    label: { typeof: String },
    fullPath: {
      typeof: String,
    },
    folders: {
      typeof: Array,
      default() {
        return [];
      },
    },
    files: {
      typeof: Array,
      default() {
        return [];
      },
    },
    isVisible: { typeof: Boolean, default: () => true },
    selectionVal: { typeof: Number },
  },
  data() {
    return {
      isSelected: 0,
      halfSelected: new Set(),
      selected: new Set(),
      maxCount: 0,
      isCollapsed: false,
    };
  },
  mounted() {
    if (this.folders && this.files)
      this.maxCount = this.folders.length + this.files.length;
  },
  watch: {
    selectionVal(val) {
      this.parentUpdated(val);
    },
  },
  computed: {},
  methods: {
    addToSelected(name) {
      if (!this.selected.has(name)) this.selected.add(name);
      if (this.halfSelected.has(name)) this.halfSelected.delete(name);
    },
    addToHalfSelected(name) {
      if (this.selected.has(name)) this.selected.delete(name);
      if (!this.halfSelected.has(name)) this.halfSelected.add(name);
    },
    deleteFromSelected(name) {
      if (this.selected.has(name)) this.selected.delete(name);
      if (this.halfSelected.has(name)) this.halfSelected.delete(name);
    },
    childrenUpdated(val, name) {
      if (val === 2) {
        this.addToSelected(name);
      } else if (val === 0) {
        this.deleteFromSelected(name);
      } else if (val === 1) {
        this.addToHalfSelected(name);
      }

      this.checkState();

      this.$emit('selectionValEv', this.isSelected, this.label);
    },

    fileUpdated(val, name) {
      this.childrenUpdated(val, name);
      this.emitFileSelChanged(val, name);
    },

    emitFileSelChanged(val, name) {
      this.$emit('fileSelectionChanged', val, this.label + '/' + name);
    },

    thisUpdated(val) {
      this.updateChildrens(val);

      if (val === 2) {
        this.isSelected = 2;
        this.$emit('selectionValEv', this.isSelected, this.label);
      } else if (val === 0) {
        this.isSelected = 0;
        this.$emit('selectionValEv', this.isSelected, this.label);
      }
    },
    parentUpdated(val) {
      this.updateChildrens(val);
    },

    updateChildrens(val) {
      this.maxCount = 0;

      this.folders.forEach((folder) => {
        if (folder.isVisible) {
          this.maxCount++;

          if (val === 1) {
            if (folder.isSelected == 2) this.addToSelected(folder.name);
            else if (folder.isSelected == 1)
              this.addToHalfSelected(folder.name);
            else this.deleteFromSelected(folder.name);
          } else {
            folder.isSelected = val;
            if (val === 0) this.deleteFromSelected(folder.name);
            else this.addToSelected(folder.name);
          }
        } else {
          this.deleteFromSelected(folder.name);
        }
      });
      this.files.forEach((file) => {
        if (file.isVisible) {
          this.maxCount++;

          if (val == 1) {
            if (file.isSelected == 2) this.addToSelected(file.name);
            else this.deleteFromSelected(file.name);
          } else {
            file.isSelected = val;
            this.emitFileSelChanged(val, file.name);

            if (val === 0) this.deleteFromSelected(file.name);
            else this.addToSelected(file.name);
          }
        } else {
          this.deleteFromSelected(file.name);
        }
      });

      this.checkState();
    },

    checkState() {
      if (this.maxCount === this.selected.size) {
        this.isSelected = 2;
      } else if (this.selected.size > 0 || this.halfSelected.size > 0) {
        this.isSelected = 1;
      } else {
        this.isSelected = 0;
      }
    },

    onCollapsedBtn() {
      this.isCollapsed = !this.isCollapsed;
    },
  },
};
</script>
